import React from 'react';
import styled from 'styled-components';
import { secondaryFont, wLight } from 'Utils/utilsStyle';

type Props = {
  name?: string,
  backgroundColor?: string,
  index?: number,
} & typeof defaultProps;

const defaultProps = {
  name: 'Competitive',
  backgroundColor: '#FF0019',
  index: 0,
};

const Wrapper = styled.span`
  border-radius:22px;
  margin:0 4px;
  padding:5px 18px;
  color:#fff;
  font-size:16px;
  font-family:${secondaryFont};
  font-weight:${wLight};
  display: inline-block;
  margin-bottom: 10px;
`;

const PersonaQualities = function PersonaQualities({ name, backgroundColor, index }: Props) {
  return (
    <Wrapper style={{ backgroundColor: `${backgroundColor}` }} tabIndex={index}>
      {name}
    </Wrapper>
  );
};

PersonaQualities.defaultProps = defaultProps;

export default PersonaQualities;
